<template>
  <div class="free-trial-container">
    <header>
      <span class="title">免审设置</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="请输入内容" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-button size="small" type="primary" @click="add" v-if="funAuth.includes(59)">新 增</el-button>
      </div>
    </header>
    <el-table class="el-table-01" :data='tableList' style='width: 100%' @selection-change='handleSelectionChange' @row-click="rowClick">
      <el-table-column type='selection' width='55'></el-table-column>
      <el-table-column label='规则名称' prop='regulation_name' min-width='260'></el-table-column>
      <el-table-column label='部署方式' prop='deployment_type' min-width='140'>
        <template slot-scope='scope'>
          {{scope.row.deployment_type == 1 ? '本地初始化':'云服务初始化'}}
        </template>
      </el-table-column>
      <el-table-column label='注册开始时间' prop='register_start_time' min-width='160'>
        <template slot-scope='scope'>
          {{scope.row.register_start_time | formatDate('yyyy-MM-dd')}}
        </template>
      </el-table-column>
      <el-table-column label='注册结束时间' prop='register_end_time' min-width='160'>
        <template slot-scope='scope'>
          {{scope.row.register_end_time | formatDate('yyyy-MM-dd')}}
        </template>
      </el-table-column>
      <el-table-column label='开通版本' prop='strategy_id' min-width='140'>
        <template slot-scope='scope'>
          <span v-text="strategyInit(scope.row.strategy_id)"></span>
        </template>
      </el-table-column>
      <el-table-column label='组件版本' prop='cm_id' min-width='140'>
        <template slot-scope='scope'>
          <span v-text="cmInit(scope.row.cm_id)"></span>
        </template>
      </el-table-column>
      <el-table-column label='使用时长' prop='use_day' min-width='140'></el-table-column>
      <el-table-column label='开通坐席' prop='allow_number' min-width='140'></el-table-column>
      <el-table-column label='总数据量' prop='data_size' min-width='140'>
        <template slot-scope='scope'>{{scope.row.data_size || '-'}}</template>
      </el-table-column>
      <el-table-column label='附件空间' prop='attachment_size' min-width='140'>
        <template slot-scope='scope'>{{scope.row.attachment_size || '-'}}</template>
      </el-table-column>
      <el-table-column label='状态' prop='status' min-width='120'>
        <template slot-scope='scope'>
          <el-switch :value="scope.row.status == 1" active-color="#1890FF" inactive-color="#dcdfe6" @change="disable(scope.row)" :disabled="!funAuth.includes(62)"></el-switch>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>

    <el-dialog title="提示" :visible.sync="dialogDisable" class="prompt-box">
      <i class="iconfont icon-prompt-box"></i>
      <div class="content" style="margin-bottom: 6px;">提示</div>
      <!-- <div class="note">提示</div> -->
      <div class="prompt">你确定要{{setting.status == 1 ? '停用':'启用'}}该规则吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDisable = false">取 消</el-button>
        <el-button type="primary" @click="disableConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box">
      <i class="iconfont icon-prompt-box"></i>
      <div class="content" style="margin-bottom: 6px;">删除</div>
      <!-- <div class="note">删除</div> -->
      <div class="prompt">确定要删除该设置吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="userDelete">确 定</el-button>
      </span>
    </el-dialog>

    <div class="mask n2" v-if="dialogDetail" @click="dialogDetail = false"></div>
    <transition name="slide">
      <el-container class="data-detail-wrip" v-if="dialogDetail">
        <header>
          <img src="/static/images/icon-company.png">
          {{detail.regulation_name}}
          <i class="iconfont icon-close" @click="dialogDetail = false"></i>
        </header>
        <div class="tab-box">
          <div class="tab-item" :class="(tabType == 0)?'active':''" @click="dtlChange(0)"><span>免审设置</span></div>
          <div class="tab-item" :class="(tabType == 1)?'active':''" @click="dtlChange(1)"><span>操作记录</span></div>
        </div>
        <div class="head" v-if="tabType == 0">
          <span>免审设置</span>
          <el-dropdown trigger="click" @command="handleCommand" v-if="funAuth.includes(61)">
            <span class="el-dropdown-link">
              <i class="el-icon-arrow-down el-icon-more"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">删  除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="edit" v-if="funAuth.includes(60)">编 辑</el-button>
        </div>
        <div class="head" v-if="tabType == 1">
          <span>操作记录</span>
        </div>
        <div class="content">
          <el-collapse v-model="activeNames" v-if="tabType == 0">
            <el-collapse-item name="1">
              <template slot="title">
                <i class="iconfont icon-zhankai"></i>
                基本信息
              </template>
              <div class="form">
                <div class="item single">
                  <span class="title">规则名称</span>
                  <div class="item-content">{{detail.regulation_name}}</div>
                </div>
                <div class="liner">免审条件</div>
                <div class="item single">
                  <span class="title">部署方式</span>
                  <div class="item-content">{{detail.deployment_type == 1 ? '本地初始化':'云服务初始化'}}</div>
                </div>
                <div class="item">
                  <span class="title">注册开始时间</span>
                  <div class="item-content">{{detail.register_start_time | formatDate('yyyy-MM-dd')}}</div>
                </div>
                <div class="item">
                  <span class="title">注册结束时间</span>
                  <div class="item-content">{{detail.register_end_time | formatDate('yyyy-MM-dd')}}</div>
                </div>
                <div class="liner">免审条件</div>
                <div class="item">
                  <span class="title">开通版本</span>
                  <div class="item-content" v-text="strategyInit(detail.strategy_id)"></div>
                </div>
                <div class="item">
                  <span class="title">组件版本</span>
                  <div class="item-content" v-text="cmInit(detail.cm_id)"></div>
                </div>
                <div class="item">
                  <span class="title">使用时长</span>
                  <div class="item-content">{{detail.use_day}}天</div>
                </div>
                <div class="item">
                  <span class="title">开通坐席</span>
                  <div class="item-content">{{detail.allow_number}}人</div>
                </div>
                <div class="item" v-if="detail.deployment_type === 0">
                  <span class="title">总数据量</span>
                  <div class="item-content">{{detail.data_size}}条</div>
                </div>
                <div class="item" v-if="detail.deployment_type === 0">
                  <span class="title">附件空间</span>
                  <div class="item-content">{{detail.attachment_size}}GB</div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="2">
              <template slot="title">
                <i class="iconfont icon-zhankai"></i>
                系统信息
              </template>
              <div class="form">
                <div class="item">
                  <span class="title">创建人</span>
                  <div class="item-content">{{detail.create_by}}</div>
                </div>
                <div class="item">
                  <span class="title">创建时间</span>
                  <div class="item-content">{{detail.create_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                </div>
                <div class="item">
                  <span class="title">修改人</span>
                  <div class="item-content">{{detail.modify_by}}</div>
                </div>
                <div class="item">
                  <span class="title">修改时间</span>
                  <div class="item-content">{{detail.modify_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div class="log-box" v-if="tabType == 1">
            <div class="log-item" v-for="(date, index) in logList" :key="index">
              <div class="line">
                <div class="circle"></div>
              </div>
              <div class="rihgt">
                <div class="time">{{date.datetime_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                <div class="content">{{date.content}}</div>
              </div>
            </div>
          </div>
        </div>
      </el-container>
    </transition>
    <div class="mask n1" v-if="dialogAdd" @click="dialogAdd = false"></div>
    <transition name="slide">
      <el-container class="add-dialog" v-if="dialogAdd">
        <header>
          <span>免审设置</span>
          <i class="iconfont icon-close" @click="dialogAdd = false"></i>
        </header>
        <div class="content">
          <div class="banner">
            <div class="h1">免审设置</div>
            <div class="h2">注册免审设置</div>
          </div>
          <div class="form">
            <div class="form-header">基本信息</div>
            <div class="form-content">
              <div class="form-item single">
                <span class="item-title"><span class="need">*</span>规则名称</span>
                <div class="item-right">
                  <el-input v-model="regulationName" placeholder="请输入(必填)" size="medium" maxlength="50"></el-input>
                </div>
                <div class="err" v-if="err_rn"><i class="el-icon-warning"></i>{{err_rn}}</div>
              </div>

              <div class="form-item single">
                <span class="item-title">免审条件</span>
                <div class="item-right">
                  <div class="item-right-box">
                    <div class="form-item single">
                      <span class="item-title"><span class="need">*</span>部署方式</span>
                      <div class="item-right">
                        <el-select v-model="deployment_type" placeholder="请选择(必填)" size="medium">
                          <el-option v-for="item in configuration" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </div>
                      <div class="err" v-if="err_dt"><i class="el-icon-warning"></i>{{err_dt}}</div>
                    </div>
                    <div class="form-item single">
                      <span class="item-title"><span class="need">*</span><span>注册开始时间</span></span>
                      <div class="item-right">
                        <el-date-picker v-model="startDate" type="datetime" placeholder="选择日期" value-format="timestamp" size="medium" @change="startChange" format="yyyy-MM-dd HH:mm"></el-date-picker>
                      </div>
                      <div class="err" v-if="err_sd"><i class="el-icon-warning"></i>{{err_sd}}</div>
                    </div>
                    <div class="form-item single">
                      <span class="item-title"><span class="need">*</span><span>注册结束时间</span></span>
                      <div class="item-right">
                        <el-date-picker v-model="endDate" type="datetime" placeholder="选择日期" value-format="timestamp" size="medium" @change="endChange" format="yyyy-MM-dd HH:mm"></el-date-picker>
                      </div>
                      <div class="err" v-if="err_ed"><i class="el-icon-warning"></i>{{err_ed}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-item single">
                <span class="item-title">内容&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <div class="item-right">
                  <div class="item-right-box">
                    <div class="form-item">
                      <span class="item-title"><span class="need">*</span>开通版本</span>
                      <div class="item-right">
                        <el-select v-model="version" placeholder="请选择(必填)" size="medium">
                          <el-option v-for="item in vOptions" :key="item.id" :label="item.version_name" :value="item.id"></el-option>
                        </el-select>
                      </div>
                      <div class="err" v-if="err_v"><i class="el-icon-warning"></i>{{err_v}}</div>
                    </div>
                    <div class="form-item">
                      <span class="item-title"><span class="need">*</span>组件版本</span>
                      <div class="item-right">
                        <el-select v-model="field_typesId" placeholder="请选择(必填)" size="medium">
                          <el-option v-for="item in componentData" :key="item.id" :label="item.cm_name" :value="item.id"></el-option>
                        </el-select>
                      </div>
                      <div class="err" v-if="err_ft"><i class="el-icon-warning"></i>{{err_ft}}</div>
                    </div>
                    <div class="form-item">
                      <span class="item-title"><span class="need">*</span>使用时长</span>
                      <div class="item-right">
                        <el-input v-model="useDay" placeholder="请输入(必填)" size="medium" type="number" class="tian"></el-input>
                      </div>
                      <div class="err" v-if="err_ud"><i class="el-icon-warning"></i>{{err_ud}}</div>
                    </div>
                    <div class="form-item">
                      <span class="item-title"><span class="need">*</span>开通坐席</span>
                      <div class="item-right">
                        <el-input v-model="peopleNumber" placeholder="请输入(必填)" size="medium" type="number" class="ren"></el-input>
                      </div>
                      <div class="err" v-if="err_pn"><i class="el-icon-warning"></i>{{err_pn}}</div>
                    </div>
                    <div class="form-item" v-if="deployment_type === 0">
                      <span class="item-title"><span class="need">*</span>附件空间</span>
                      <div class="item-right">
                        <el-input v-model="attachment" placeholder="请输入(必填)" size="medium" class="gb" type="number">
                        </el-input>
                      </div>
                      <div class="err" v-if="err_a"><i class="el-icon-warning"></i>{{err_a}}</div>
                    </div>
                    <div class="form-item" v-if="deployment_type === 0">
                      <span class="item-title"><span class="need">*</span>总数据量</span>
                      <div class="item-right">
                        <el-input v-model="dataSize" placeholder="请输入(必填)" size="medium" class="tiao" type="number">
                        </el-input>
                      </div>
                      <div class="err" v-if="err_ds"><i class="el-icon-warning"></i>{{err_ds}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <el-button @click="dialogAdd = false">取 消</el-button>
          <el-button type="primary" @click="dialogSave">保 存</el-button>
        </footer>
      </el-container>
    </transition>
  </div>
</template>
<script>
import {HTTPServer} from '@/common/js/ajax.js'
import customerAdd from '@/common/components/customer-add'// 新增
import mixin from '@/common/js/mixins.js'
export default {
  data () {
    return {
      defaultMsg: '<b>免审设置</b>',
      searchInput: '',
      tableList: [],
      moduleId: 18,
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      dialogDisable: false,
      dialogDelete: false,
      dialogDetail: false,
      detail: {},
      activeNames: ['1', '2', '3'],
      dialogAdd: false,
      tabType: 0,
      regulationName: '',
      userName: '',
      phone: '',
      password: '',
      version: '',
      peopleNumber: '',
      startDate: new Date().getTime(),
      endDate: new Date().getTime(),
      attachment: '',
      dataSize: '',
      field_typesId: '',
      componentData: [],
      deployment_type: 0,
      useDay: '',
      err_rn: '',
      err_v: '',
      err_ft: '',
      err_pn: '',
      err_sd: '',
      err_ed: '',
      err_a: '',
      err_ds: '',
      err_dt: '',
      err_ud: '',
      setting: {},
      configuration: [{'label': '云服务初始化', 'id': 0}, {'label': '本地初始化', 'id': 1}]
    }
  },
  mixins: [mixin],
  mounted () {
    this.queryAllChargingStrategy()
    this.getEnableComponentManageList()
    this.queryCustomerAuditRegulationList()
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
  },
  components: {
    customerAdd
  },
  methods: {
    strategyInit (id) {
      var text = ''
      this.vOptions.map((item) => {
        if (item.id === id) {
          text = item.version_name
        }
      })
      return text
    },
    cmInit (id) {
      var text = ''
      this.componentData.map((item) => {
        if (item.id === id) {
          text = item.cm_name
        }
      })
      return text
    },
    /** 获取注册客户 */
    queryCustomerAuditRegulationList (id) {
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'keyWord': this.searchValue}
      HTTPServer.queryCustomerAuditRegulationList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
        if (id) {
          this.tableList.map((item) => {
            if (item.id === id) {
              this.detail = JSON.parse(JSON.stringify(item))
            }
          })
        }
      })
    },
    /** 列表选择 */
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.queryCustomerAuditRegulationList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.queryCustomerAuditRegulationList()
    },
    /** 搜索列表 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.queryCustomerAuditRegulationList()
    },
    // 新增
    add () {
      var date = new Date()
      this.regulationName = ''
      this.deployment_type = 0
      this.startDate = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' 00:00:00').getTime()
      this.endDate = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' 23:59:59').getTime()
      this.version = ''
      this.field_typesId = ''
      this.useDay = ''
      this.peopleNumber = ''
      this.dataSize = ''
      this.attachment = ''
      this.dialogAdd = true
      this.detail = {}
    },
    // 开始时间切换
    startChange (ev) {
      let date = new Date(ev)
      this.startDate = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':00').getTime()
    },
    // 结束时间切换
    endChange (ev) {
      let date = new Date(ev)
      this.endDate = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':59').getTime()
    },
    disable (row) {
      this.dialogDisable = true
      this.setting = row
    },
    /** 禁用 */
    disableConfirm () {
      var jsondata = {'id': this.setting.id, 'status': this.setting.status === 1 ? 0 : 1}
      console.log(this.setting)
      console.log(jsondata)
      HTTPServer.enableDisableCustomerAuditRegulation(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.dialogDisable = false
        this.queryCustomerAuditRegulationList()
      })
    },
    /** 删除客户 */
    userDelete () {
      var jsondata = {'id': this.detail.id}
      HTTPServer.deleteCustomerAuditRegulation(jsondata, 'Loading').then((res) => {
        this.dialogDelete = false
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.pageNum = 1
        this.searchValue = ''
        this.queryCustomerAuditRegulationList()
        if (this.dialogDetail) {
          this.dialogDetail = false
        }
      })
    },
    /** 进入客户详情 */
    rowClick (row, event, column) {
      console.log(row, event, column)
      if (column.property !== 'status') {
        this.activeNames = ['1', '2']
        this.tabType = 0
        this.detail = JSON.parse(JSON.stringify(row))
        this.dialogDetail = true
      }
    },
    /** 点击菜单项触发的事件回调 */
    handleCommand (command) {
      if (command === '1') {
        this.dialogDelete = true
      }
    },
    /** 编辑客户 */
    edit () {
      this.regulationName = this.detail.regulation_name
      this.deployment_type = this.detail.deployment_type
      this.startDate = this.detail.register_start_time
      this.endDate = this.detail.register_end_time
      this.version = this.detail.strategy_id
      this.field_typesId = this.detail.cm_id
      this.useDay = this.detail.use_day
      this.peopleNumber = this.detail.allow_number
      this.dataSize = this.detail.data_size
      this.attachment = this.detail.attachment_size
      this.dialogAdd = true
    },
    /** 获取 组件管理 */
    getEnableComponentManageList (id) {
      HTTPServer.getEnableComponentManageList({}, 'Loading').then((res) => {
        this.componentData = res
        let firstId = ''
        res.map((item) => {
          if (!firstId) firstId = item.id
          if (item.id === id) {
            this.field_typesId = item.id
          }
        })
      })
    },
    /** 详情导航切换 */
    dtlChange (type) {
      this.tabType = type
      if (type === 1) {
        this.queryRecordList({moduleType: this.moduleId, moduleId: this.detail.id})
      }
    },
    // 数据保存、编辑
    dialogSave () {
      this.err_rn = ''
      this.err_sd = ''
      this.err_ed = ''
      this.err_v = ''
      this.err_ft = ''
      this.err_ud = ''
      this.err_pn = ''
      this.err_ds = ''
      this.err_a = ''
      console.log(this.startDate, this.endDate)
      let reg = /^[1-9]\d*$/
      if (!this.regulationName) {
        this.err_rn = '规则名称不能为空'
        return
      }
      if (!this.startDate) {
        this.err_sd = '套餐开始日期不能为空'
        return false
      }
      if (!this.endDate) {
        this.err_ed = '套餐结束日期不能为空'
        return false
      }
      if (this.startDate >= this.endDate) {
        this.err_ed = '套餐结束日期不能小于或等于开始时间'
        return false
      }
      if (!this.version) {
        this.err_v = '开通版本不能为空'
        return
      }
      if (!this.field_typesId) {
        this.err_ft = '组件版本不能为空'
        return
      }
      if (!this.useDay) {
        this.err_ud = '使用时长不能为空'
        return
      }
      if (!this.peopleNumber) {
        this.err_pn = '开通坐席不能为空'
        return
      }
      if (!reg.test(this.peopleNumber)) {
        this.err_pn = '开通坐席只能为正整数'
        return false
      }
      if (this.deployment_type === 0 && !this.attachment) {
        this.err_a = '附件空间不能为空'
        return false
      }
      if (this.deployment_type === 0 && !reg.test(this.attachment)) {
        this.err_a = '附件空间只能为正整数'
        return false
      }
      if (this.deployment_type === 0 && !this.dataSize) {
        this.err_ds = '总数据量不能为空'
        return false
      }
      let jsondata = {
        'regulation_name': this.regulationName, // 规则名称
        'deployment_type': this.deployment_type, // 部署方式0: 云部署 1:本地部署
        'register_start_time': this.startDate, // 注册开始时间
        'register_end_time': this.endDate, // 注册结束时间
        'strategy_id': this.version, // 开通版本
        'cm_id': this.field_typesId, // 组件版本
        'use_day': this.useDay, // 使用时长
        'allow_number': this.peopleNumber, // 开通坐席
        'data_size': this.dataSize, // 总数据量
        'attachment_size': this.attachment // 附件空间
      }
      if (this.deployment_type === 1) {
        delete jsondata.data_size
        delete jsondata.attachment_size
      }
      console.log(jsondata)
      if (this.detail.id) {
        jsondata.id = this.detail.id
        HTTPServer.editCustomerAuditRegulation(jsondata, 'Loading').then((res) => {
          this.dialogAdd = false
          this.$message({
            showClose: true,
            message: '操作成功！',
            type: 'success'
          })
          this.queryCustomerAuditRegulationList(this.detail.id)
        })
      } else {
        HTTPServer.saveCustomerAuditRegulation(jsondata, 'Loading').then((res) => {
          this.dialogAdd = false
          this.$message({
            showClose: true,
            message: '操作成功！',
            type: 'success'
          })
          this.queryCustomerAuditRegulationList()
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.free-trial-container{
  .el-table{
    height: calc(100% - 120px);
    .s0::before{
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #1890FF;
      float: left;
      margin: 8.5px 10px 0 0;
      border-radius: 50%;
    }
    .s2::before{
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #FF0000;
      float: left;
      margin: 8.5px 10px 0 0;
      border-radius: 50%;
    }
  }
  .data-detail-wrip{
    .liner{
      line-height: 58px;
      height: 50px;
      float: left;
      width: 100%;
      font-size: 14px;
      color: #333333;
    }
  }
  .item-right-box{
    overflow: hidden;
    margin-top: 40px;
    width: calc(100% + 90px);
    margin-left: -90px;
    border: 1px solid rgba(0,0,0,0.15);
    padding: 20px 0 4px;
    .form-item.single{
      width: calc(100% - 20px);
    }
    .form-item{
      width: calc(50% - 10px);
    }
    .item-title{
      width: 124px;
    }
    .item-right{
      width: calc(100% - 124px);
      margin-left: 124px;
    }
    .err{
      padding-left: 134px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/customer/freeTrial.vue